package one.healthium.domain.paywall.models


import kotlinx.serialization.Contextual
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.Color
import one.healthium.domain.common.Insets
import one.healthium.domain.common.PlatformValueSerializer


@Serializable
data class ProductControlConfig(
    @SerialName("controls") val controls: List<ProductControl> = emptyList(),
    @SerialName("height") val height: Int? = null,
    @SerialName("horizontal_inset") val horizontalInset: Int? = null,
)


@Serializable
data class ProductControl(
    @SerialName("product") @Serializable(with = PlatformValueSerializer::class) val product: String,
    @SerialName("border_width") val borderWidth: String? = null,
    @SerialName("background_color") @Contextual val backgroundColor: Color? = null,
    @SerialName("selected_border_color") @Contextual val selectedBorderColor: Color? = null,
    @SerialName("columns") val columns: List<Column> = emptyList(),
)


@Serializable
data class Column(
    @SerialName("weight") val weight: Int? = null,
    @SerialName("alignment") val alignment: String? = null,
    @SerialName("lines") val lines: List<AttributedLine> = emptyList(),
)


@Serializable
data class AttributedLine(
    @SerialName("insets") val insets: Insets? = null,
    @SerialName("color") @Contextual val color: Color? = null,
    @SerialName("words") val words: List<Word> = emptyList(),
)


@Serializable
data class Word(
    @SerialName("template") val template: String? = null,
    @SerialName("color") @Contextual val color: Color? = null,
    @SerialName("font_size") val fontSize: Int? = null,
    @SerialName("font_style") val fontWeight: String? = null,
    @SerialName("stroke") val stroke: TextStrokeStyle? = null,
    @SerialName("letter") val letterSpacing: Float? = null,
    @SerialName("line_height") val lineHeight: Float? = null,
)


@Serializable
enum class TextStrokeStyle {
    @SerialName("through")
    Through,

    @SerialName("none")
    None,
}